<template>
  <div></div>
</template>

<script>
import smartMixins from './smartMixins'

export default {
  name: 'Statistics',
  mixins: [smartMixins],
  components: {},
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped>
</style>